import { authGateway } from "@/gateways/authGateway";
import type { MutationCallbacks } from "@/types";
import { useMutation } from "@tanstack/vue-query";

export function useLogin(callbacks: MutationCallbacks = {}) {
  const mutation = useMutation({
    mutationFn: (email: string) =>
      authGateway.login(email.trim().toLowerCase()),
    onSuccess() {
      callbacks.onSuccess?.();
    },
  });

  return { ...mutation, login: mutation.mutate };
}
